import styled from 'styled-components';
import GoldTrophy from '../../../assets/gold.png';
import SilverTrophy from '../../../assets/silver.png';
import BronzeTrophy from '../../../assets/bronze.png';

export const HeaderWrapper = styled.div`
    margin: 60px auto;
    padding: 0 12px;
    text-align: center;

    @media (min-width: 480px) {
        padding: 0 18px;
    }
    @media (min-width: 768px) {
        padding: 0 30px;
    }

    @media (min-width: 1200px) {
        max-width: 90%;
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 64px;
`;

export const HeaderText = styled.div`
    line-height: 2.2;
    letter-spacing: 2px;
    padding: 24px;
    border-radius: 32px;
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;

    @media (max-width: 768px) {
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
    text-align: center;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;

    @media (min-width: 480px) {
        font-size: 16px;
        padding: 32px;
    }

    @media (min-width: 768px) {
        font-size: 18px;
        padding: 40px;
    }

    @media (min-width: 1024px) {
        max-width: 600px;
    }

    @media (min-width: 1200px) {
        font-size: 20px;
    }

    strong {
        color: ${({ $PRIMARY_FONT_COLOR }) =>
            $PRIMARY_FONT_COLOR};
        font-weight: 800;
    }
`;

export const HeaderFBLink = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: #4267b2;
`;

export const HeaderTGLink = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: #24a1de;
`;

export const HeaderIGLink = styled.a`
    text-decoration: none;
    cursor: pointer;
    color: #e1306c;
`;

export const ContributorsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 48px;
    align-items: center;
    justify-content: center;

    h2 {
        font-size: 24px;
        margin: 0 0 16px;
    }

    @media (min-width: 1024px) {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 120px;
    }
`;

export const ContributorsLeft = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    h2 {
        text-align: center;
    }

    @media (min-width: 1024px) {
        width: 50%;
        max-width: 600px;
    }
`;

export const ContributorsList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 24px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    @media (min-width: 480px) {
        max-width: 600px;
    }
`;

export const ContributorItem = styled.li`
    display: flex;
    align-items: center;
    padding: ${({ $rank }) => {
        if ($rank === 0) return '20px 22px';
        if ($rank === 1) return '14px 22px';
        if ($rank === 2) return '10px 22px';
        return '8px 18px';
    }};
    border-radius: 20px;
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;

    @media (max-width: 768px) {
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;

    background: ${({ $rank, $isDarkMode }) => {
        if ($rank === 0)
            return $isDarkMode
                ? 'rgba(212, 175, 55, 0.25)'
                : 'rgba(212, 175, 55, 0.15)';
        if ($rank === 1)
            return $isDarkMode
                ? 'rgba(192, 192, 192, 0.25)'
                : 'rgba(192, 192, 192, 0.15)';
        if ($rank === 2)
            return $isDarkMode
                ? 'rgba(205, 127, 50, 0.25)'
                : 'rgba(205, 127, 50, 0.15)';
        return $isDarkMode
            ? 'rgba(255, 255, 255, 0.05)'
            : 'rgba(255, 255, 255, 0.4)';
    }};

    ${({ $rank }) =>
        $rank === 0 &&
        `
        border-color: rgba(212, 175, 55, 0.5);
        box-shadow: 0 8px 24px rgba(212, 175, 55, 0.2), inset 0 0 1px 1px rgba(255, 255, 255, 0.2);
    `}

    ${({ $rank }) =>
        $rank === 1 &&
        `
        border-color: rgba(192, 192, 192, 0.5);
    `}

    ${({ $rank }) =>
        $rank === 2 &&
        `
        border-color: rgba(205, 127, 50, 0.5);
    `}

    /* Centered low-opacity PlayStation-like trophy background for top 3 */
    &::before {
        content: ${({ $rank }) =>
            $rank < 3 ? "''" : 'none'};
        position: absolute;
        top: 50%;
        left: 75%;
        transform: translate(-50%, -50%) rotate(-25deg);
        width: ${({ $rank }) =>
            $rank === 0
                ? '110px'
                : $rank === 1
                ? '75px'
                : $rank === 2
                ? '55px'
                : '0'};
        height: ${({ $rank }) =>
            $rank === 0
                ? '110px'
                : $rank === 1
                ? '75px'
                : $rank === 2
                ? '55px'
                : '0'};
        pointer-events: none;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        opacity: ${({ $isDarkMode }) =>
            $isDarkMode ? 0.12 : 0.18};
        background-image: ${({ $rank }) =>
            $rank === 0
                ? `url(${GoldTrophy})`
                : $rank === 1
                ? `url(${SilverTrophy})`
                : $rank === 2
                ? `url(${BronzeTrophy})`
                : 'none'};
    }
`;

export const ContributorRank = styled.span`
    font-weight: bold;
    margin-right: 12px;
    font-size: ${({ $rank }) =>
        $rank < 3 ? '18px' : '14px'};
    opacity: 0.8;
    min-width: 24px;
`;

export const ContributorInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-grow: 1;
    overflow: hidden;
`;

export const ContributorName = styled.strong`
    font-size: ${({ $rank }) =>
        $rank < 3 ? '18px' : '14px'};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ContributorValue = styled.span`
    font-size: 14px;
    opacity: 0.8;
    margin-left: auto;
`;

export const ShowAllButton = styled.button`
    padding: 12px 36px;
    font-size: 12px;
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    border-radius: 32px;
    cursor: pointer;
    font-weight: bold;
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;

    @media (max-width: 768px) {
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
    text-transform: uppercase;
    letter-spacing: 2px;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);

    &:hover {
        transform: translateY(-4px);
        background: ${({ $isDarkMode }) =>
            $isDarkMode
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(255, 255, 255, 0.55)'};
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.2),
            inset 0 0 1px 1px rgba(255, 255, 255, 0.1);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

export const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    background: ${({ $MODAL_BACKGROUND_COLOR }) =>
        $MODAL_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    border-radius: 32px;
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    will-change: transform;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.4),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    width: 90%;
    max-width: 500px;
    max-height: 85vh;
    overflow: hidden;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 100vw;
        height: 100vh;
        max-width: 100vw;
        max-height: 100vh;
        border-radius: 0;
        border: none;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
    }
`;

export const ModalHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 20;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    background: ${({ $MODAL_BACKGROUND_COLOR }) =>
        $MODAL_BACKGROUND_COLOR};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);

    @media (max-width: 768px) {
        padding: 16px 20px;
    }
`;

export const ModalTitle = styled.h3`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 1px;
    text-align: left;
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};

    @media (min-width: 768px) {
        font-size: 22px;
    }
`;

export const ModalBody = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 24px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 16px 20px;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            margin-bottom: 8px;
            font-size: 12px;
            background: ${({ $isDarkMode }) =>
                $isDarkMode
                    ? 'rgba(255, 255, 255, 0.03)'
                    : 'rgba(255, 255, 255, 0.4)'};
            border-radius: 16px;
            border: 1px solid transparent;

            &:last-child {
                margin-bottom: 0;
            }

            span:first-child {
                font-weight: bold;
                opacity: 0.5;
                margin-right: 12px;
                min-width: 24px;
            }

            strong {
                color: ${({ $PRIMARY_FONT_COLOR }) =>
                    $PRIMARY_FONT_COLOR};
                margin: 0 12px;
                flex-grow: 1;
            }

            .scarf-count {
                margin-left: auto;
                opacity: 0.7;
                font-size: 10px;
            }

            @media (min-width: 768px) {
                font-size: 16px;
                .scarf-count {
                    font-size: 14px;
                }
            }
        }
    }
`;

export const ModalFooter = styled.div`
    position: sticky;
    bottom: 0;
    z-index: 20;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 24px;
    border-top: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    background: ${({ $MODAL_BACKGROUND_COLOR }) =>
        $MODAL_BACKGROUND_COLOR};
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);

    @media (max-width: 768px) {
        padding: 14px 20px;
    }
`;

export const CloseButton = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);

    @media (max-width: 768px) {
        width: 36px;
        height: 36px;
    }

    &:hover {
        transform: scale(1.1);
        background: ${({ $isDarkMode }) =>
            $isDarkMode
                ? 'rgba(255, 255, 255, 0.1)'
                : 'rgba(255, 255, 255, 0.6)'};
    }
`;

export const ContributorsRight = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;

    @media (min-width: 1024px) {
        width: 50%;
        max-width: 600px;
        min-width: 500px;
    }

    @media (max-width: 1024px) {
        min-width: 300px;
    }
`;

export const ChartCard = styled.div`
    width: 100%;
    max-width: 500px;
    height: 500px;

    @media (max-width: 1024px) {
        max-width: 100%;
        height: 400px;
    }

    @media (max-width: 480px) {
        height: 300px;
    }
`;

export const HeaderTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (min-width: 1024px) {
        flex-direction: row;
        align-items: stretch;
        justify-content: center;
        gap: 120px;
        min-height: 400px;
    }
`;

export const CarouselWrapper = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1024px) {
        width: 100%;
        margin: 40px auto 0;
    }
`;
